module.exports = __webpack_public_path__ + "static/media/icon_certification.ada4c6af.png";